import { t } from '@lingui/core/macro';
import * as yup from 'yup';
export function getValidationSchema() {
    return yup.object({
        selectedIds: yup
            .array()
            .of(yup.string().required())
            .min(1, t({
            message: 'Select at least one property to sync',
            comment: 'HubSpot metadata: validation when no properties are selected',
        })),
    });
}
